<template>
  <div
    style="
      display: grid;
      align-self: center;
      grid-template-columns: 50px 1fr 40px;
      grid-gap: 10px;
    "
  >
    <img
      :src="getBankLogo(item.bank_id)"
      :alt="item.name"
      width="50"
      height="50"
      style="align-self: start"
    />
    <div style="display: grid">
      <div>
        <a
          class="bluelink bank_name"
          @click.prevent="showBankInfo(item.product_id)"
          href
          >{{ item.bank }}
        </a>
        <v-icon right small style="margin: 0" @click="() => getShortInfo(item)"
          >info</v-icon
        >

        <v-icon
          right
          small
          @click="() => CalculationShow(item.calculation)"
          v-if="role() == roleObj.bankir || role() == roleObj.adminService"
          >fa fa-calculator</v-icon
        >
        <br />
        <a class="bluelink" @click.prevent="showRateInfo(item)" href>{{
          item.product
        }}</a>
        <br />
        {{ item.acra }} / {{ item.raexpert }} / {{ item.npa }} / {{ item.nkp }}
      </div>
    </div>
  </div>
</template>
<script>
import { roleObj } from "@/plugins/roles";

export default {
  name: "BankInfo",
  data: () => ({
    roleObj,
  }),
  props: {
    item: { type: Object },
  },
  methods: {
    showBankInfo(product_id) {
      this.$store.dispatch("getBankViewData", product_id).then(() => {
        this.$emit("setBankViewData");
        this.$store.commit("SET_BANK_VIEW_DIALOG", true);
      });
    },
    getBankLogo(bank_id) {
      const logos = this.$store.getters.getBanksLogos;
      const filter = logos.filter((item) => item.id === bank_id);
      return filter.length && filter[0] && filter[0].logo
        ? filter[0].logo
        : null;
    },
    async getShortInfo(item) {
      const data = await this.$store.dispatch(
        "GET_SHORT_INFO",
        item.product_id
      );
      this.$emit("dialog", { dialog: true, dialogText: data.short_info });
    },
    CalculationShow(calc) {
      this.$emit("dialog", { dialog: true, dialogText: calc });
    },
    showRateInfo(item) {
      this.$store.commit("setBankId", item.bank_id);
      this.$store.commit("setBankRate", item.rate);
      this.$store.commit("setProductId", item.product_id);
      this.$store.dispatch("getRateViewData", item.product_id).then(() => {
        this.$emit("setRateViewData");
        this.$store.commit("SET_RATE_VIEW_DIALOG", true);
      });
    },
  },
};
</script>
<style lang="sass" scoped></style>
